import { useCallback } from 'react'
import { useDisconnect } from 'wagmi'

import { useConfirmDialog } from '@/components/confirm-dialog'
import { TOKEN } from '@/constants/local-storage'
import { setToken } from '@/redux/global-actions'
import { useAppDispatch } from '@/redux/utils'

export default function useLogout() {
  const confirm = useConfirmDialog()
  const { disconnect } = useDisconnect()
  const dispatch = useAppDispatch()

  const onConfirmLogout = useCallback(() => {
    disconnect()
    dispatch(setToken(undefined))
    window.localStorage.removeItem(TOKEN)
    window.location.href = '/'
  }, [disconnect, dispatch])

  const onLogout = useCallback(() => {
    confirm({
      title: 'Logout',
      description: 'Are you sure you want to logout?',
      onConfirm: onConfirmLogout,
    })
  }, [confirm, onConfirmLogout])

  return [onLogout, onConfirmLogout]
}
